import React from "react";

import PageBanner from "../components/common/PageBanner";
import Services from "../components/HomePageComponents/Services";

import servicesBanner from "../assets/services-banner.jpg";

const ServicesPage = () => {
  return (
    <>
      <PageBanner title="Our Services" bgImage={servicesBanner} />
      <Services />
    </>
  );
};

export default ServicesPage;
